import * as _4 from 'lodash4';
import { EnumeratedSet } from 'utility-js-enumeration';
import { NotificationSettingsDTDs } from '../constants/notification_settings_dtds';

angular
  .module('capability-ng-notification-settings')
  .factory(
    'NotificationSettingsBuilder',
    (Interface: any, NotificationSettingsDTD: NotificationSettingsDTDs, notificationSettingEnum: EnumeratedSet) => {
      function NotificationSettingsDTO(this: any, data: any) {
        _4.forEach(data.categories, (category) => {
          category.preferences = category.nk;
        });

        Interface.implement(NotificationSettingsDTD, data, this);

        _4.forEach(data.categories, (category) => {
          _4.map(category.preferences, (value, key: string) => {
            let preferenceOption = 'DEFAULT_OPT_OUT';
            switch (key) {
              case 'EMAIL': {
                preferenceOption = category.email_send;
                break;
              }
              case 'PUSH': {
                preferenceOption = category.push_send;
                break;
              }
              case 'TEXT': {
                preferenceOption = category.sms_send;
                break;
              }
              default: {
                break;
              }
            }
            category.preferences[key] = {
              preferenceType: notificationSettingEnum.get(key),
              status: value,
              option: preferenceOption
            };
          });
        });
      }
      return NotificationSettingsDTO;
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/builders/notification_settings_builder.ts